module.exports = __webpack_public_path__ + "static/media/6.1af9f014.jpg";